import React, { useEffect } from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Editor from "./editorTerms";
import EditorPolicy from "./editorPolicy";
import Utils from "../../../../utility";
import { termsPolicyService } from "../../../../services/index";
import { eventConstants } from "../../../../constants";
import { Policy } from "@material-ui/icons";
import toast, { Toaster } from "react-hot-toast";
import CommonToasts from "../../../../common/components/commonToast";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  AppBar: {
    backgroundColor: "#eeeee",
  },
}));

export default function FullWidthTabs() {
  const theme = useTheme();
  const [isLoading, setLoading] = React.useState(true);
  const [value, setValue] = React.useState(0);
  const [term, setTerm] = React.useState();
  const [policy, setPolicy] = React.useState();
  const [newPolicy, setNewPolicy] = React.useState();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };
  const handleEditorChange = (value, tab) => {

    if (tab === eventConstants.terms) setTerm(value);
    if (tab === eventConstants.policy) setPolicy(value);
  };

  useEffect(() => {
    editorTerm();
    termsCondition();
    editorPolicy();
    termsPolicy();
  }, []);

  const editorTerm = async () => {
    const reqObj = {
      text: term,
    };
    const [err, res] = await Utils.parseResponse(
      termsPolicyService.termsCondition(reqObj)
    );
    setTerm(res?.termsAndConditions);
    setLoading(false);
    if (res) {
      // Utils.apiSuccessToast("Successfully Saved");
    CommonToasts.successfullySent("Successfully Saved!!");
    }
  };

  const termsCondition = async () => {
    let [error, termsCondition] = await Utils.parseResponse(
      termsPolicyService.getTermsCondition()
    );
    if (error || !termsCondition) return;
    // setNewPolicy(termsPolicy?.privacyAndPolicy)
    setTerm(termsCondition?.termsAndConditions);
    setLoading(false);
  };

  const editorPolicy = async () => {
    const reqObj = {
      text: policy,
    };
    const [err, res] = await Utils.parseResponse(
      termsPolicyService.termsPolicy(reqObj)
    );
    setPolicy(res?.privacyAndPolicy);
    setLoading(false);
    if (res) {
      // Utils.apiSuccessToast("Successfully Saved");
    CommonToasts.successfullySent("Successfully Saved!!");
    }
  };

  const termsPolicy = async () => {
    let [error, termsPolicy] = await Utils.parseResponse(
      termsPolicyService.getTermsPolicy()
    );
    if (error || !termsPolicy) return;
    // setNewPolicy(termsPolicy?.privacyAndPolicy)
    setPolicy(termsPolicy?.privacyAndPolicy);
    setLoading(false);
  };

  return (
    <><div>
    <Toaster />
  </div>
    <Box
      sx={{ bgcolor: "background.paper", width: 758, height: 751 }}
      className="w-674"
    >
      <AppBar
        position="static"
        backgroundColor="#eeeeee"
        color="black"
        elevation={0}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab
            label="Terms and Conditions"
            {...a11yProps(0)}
            style={{ textTransform: "capitalize", color: "#1f1f1f" }}
          />
          <Tab
            label="Privacy Policy"
            {...a11yProps(1)}
            style={{ textTransform: "capitalize", color: "#1f1f1f" }}
          />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Editor
            isLoading={isLoading}
            term={term}
            handleEditorChange={handleEditorChange}
          />
          <div className="editor-btn">
            <button className="editor-savebtn w-170 h-47" onClick={editorTerm}>
              Save
            </button>
            <button className="editor-cancelbtn w-170 h-47">Cancel</button>
          </div>
        </TabPanel>

        <TabPanel value={value} index={1} dir={theme.direction}>
          {/* <EditorPolicy policy={policy} newPolicy={newPolicy}  handleEditorChange={handleEditorChange}/> */}
          <EditorPolicy
            isLoading={isLoading}
            policy={policy}
            handleEditorChange={handleEditorChange}
          />
          <div className="editor-btn">
            <button
              className="editor-savebtn w-170 h-47"
              onClick={editorPolicy}
            >
              Save
            </button>
            <button className="editor-cancelbtn w-170 h-47">Cancel</button>
          </div>
        </TabPanel>
      </SwipeableViews>
    </Box>
    </>
  );
}
